export default "__VITE_ASSET__RPBQXKWa__"